import styles from './Logs.module.scss';
import { ReactComponent as UnionIcon } from './img/iconUnion.svg';
import { ReactComponent as IconExit } from './img/iconExit.svg';
import { ReactComponent as IconLogout } from './img/iconLogout.svg';
import moment from 'moment';
import 'moment/locale/ru';
import classNames from 'classnames';
import ContentLoader from 'react-content-loader';
import {
  useEndAllSessionsMutation,
  useEndSessionMutation,
  useGetInfoUserQuery,
  useGetSessionsQuery,
} from 'redux/Api/profileApi/ProfileApi';
import { TextWithTooltip } from 'hooks/TextWithTooltip';

export const Logs = () => {
  const { data: userData } = useGetInfoUserQuery();
  const { data, isLoading, error } = useGetSessionsQuery();
  const [endSession] = useEndSessionMutation();
  const [endAllSessions] = useEndAllSessionsMutation();

  const currentSession = data?.current_device;
  const otherSessions = data?.other_devices || [];

  const formatDate = (dateString: string) => {
    if (!dateString) return '';
    return moment(dateString).format('D MMMM в HH:mm');
  };

  const handleEndSession = async (deviceToken: string) => {
    try {
      await endSession(deviceToken).unwrap();
    } catch (error) {
      console.error('Ошибка', error);
    }
  };

  const handleEndAllSessions = async () => {
    try {
      await endAllSessions().unwrap();
    } catch (error) {
      console.error('Ошибка', error);
    }
  };

  if (isLoading) {
    return (
      <ContentLoader
        speed={2}
        className={styles.loadingSkeleton}
        backgroundColor={'#FFFFFF'}
        foregroundColor={'#D8E4FB8C'}>
        <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
      </ContentLoader>
    );
  }

  if (error) {
    return null;
  }

  const isCanCloseAll = otherSessions?.some((s) => !s.is_2fa_required);

  return data && (currentSession || otherSessions.length > 0) ? (
    <div className={styles.securitySection}>
      <div className={styles.sessionsHeader}>Активные устройства</div>

      <div className={styles.session}>
        <div className={styles.sessionItem}>
          <UnionIcon />
          <div className={styles.sessionInfo}>
            <TextWithTooltip
              content={`${formatDate(
                currentSession?.last_used_at || '',
              )}, ${currentSession?.device_name}`}
              className={styles.sessionInfo_name}
            />
            <TextWithTooltip
              content={`IP ${currentSession?.ip_address}, ${currentSession?.city}`}
            />
            <div className={styles.sessionLabel}>Текущий сеанс</div>
          </div>
        </div>
      </div>

      {otherSessions.length > 0 && (
        <div className={styles.sessionsList}>
          {otherSessions.map((session) => (
            <div
              key={session.device_token}
              className={classNames(styles.session, styles.noBorder)}>
              <div className={styles.sessionItem}>
                <UnionIcon />
                <div className={styles.sessionInfo}>
                  <TextWithTooltip
                    content={`${formatDate(
                      currentSession?.last_used_at || '',
                    )}, ${currentSession?.device_name}`}
                    className={styles.sessionInfo_name}
                  />
                  <TextWithTooltip
                    content={`IP ${currentSession?.ip_address}, ${currentSession?.city}`}
                  />
                </div>
              </div>
              {!!userData?.is_2fa_enabled && !session?.is_2fa_required && (
                <>
                  <button
                    className={styles.endSessionButton}
                    onClick={() => handleEndSession(session.device_token)}>
                    Забыть устройство <IconLogout />
                  </button>
                  <div
                    className={styles.endSessionButtonMobile}
                    onClick={() => handleEndSession(session.device_token)}>
                    <IconExit />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}

      {isCanCloseAll && !!userData?.is_2fa_enabled && otherSessions.length > 0 && (
        <div className={styles.endAllSessionsButtonContainer}>
          <button className={styles.endAllSessionsButton} onClick={handleEndAllSessions}>
            Забыть все устройства <IconLogout />
          </button>
        </div>
      )}
    </div>
  ) : null;
};
